/** Reserved for the daily check-in notification. */
export const CHECKIN_NOTIFICATION_ID = 1;
/** Reserved for the end of a "give it ten minutes" timer. */
export const TIMER_NOTIFICATION_ID = 2;
/** Reserved for the summary that groups the persistent "today" notifications on the phone. */
export const TODAY_SUMMARY_NOTIFICATION_ID = 3;
const RESERVED = 4;

/** Android notification ids are 32-bit ints; derive a stable positive one from the card id. */
export function notifId(cardId: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < cardId.length; i++) {
    h ^= cardId.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  const id = h & 0x7fffffff;
  return id < RESERVED ? id + RESERVED : id;
}
